// Numbered circles + connecting lines for the wizard. Visual match for bb-traderx's
// strategy wizard progress strip (purple-500 brand, hollow inactive, filled with
// CheckCircle2 once complete).

import { CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

export interface WizardStep {
  id: string;
  label: string;
}

interface Props {
  steps: WizardStep[];
  currentIndex: number;
  onStepClick?: (index: number) => void;
}

export function StepProgress({ steps, currentIndex, onStepClick }: Props) {
  return (
    <div className="flex items-center justify-center mb-4">
      {steps.map((step, i) => {
        const isComplete = i < currentIndex;
        const isCurrent = i === currentIndex;
        const isClickable = i <= currentIndex && !!onStepClick;
        return (
          <div key={step.id} className="flex items-center">
            <button
              type="button"
              disabled={!isClickable}
              onClick={() => isClickable && onStepClick?.(i)}
              className={cn(
                "flex flex-col items-center gap-1.5 transition-opacity",
                isClickable ? "cursor-pointer hover:opacity-80" : "cursor-default",
              )}
            >
              <div
                className={cn(
                  "w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold border-2 transition-all",
                  isComplete && "bg-primary border-primary text-primary-foreground",
                  isCurrent && "border-primary text-primary bg-primary/10",
                  !isComplete && !isCurrent && "border-border text-muted-foreground",
                )}
              >
                {isComplete ? <CheckCircle2 className="size-5" /> : i + 1}
              </div>
              <span
                className={cn(
                  "text-xs font-medium whitespace-nowrap",
                  isCurrent ? "text-primary" : "text-muted-foreground",
                )}
              >
                {step.label}
              </span>
            </button>
            {i < steps.length - 1 && (
              <div
                className={cn(
                  "w-16 h-0.5 mb-5 mx-2 transition-all",
                  i < currentIndex ? "bg-primary" : "bg-border",
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
